var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Modal } from '../Modal/Modal';
import { useGlobalDispatch, useGlobalState } from '../../hooks';
import { CircleCheck } from '../../svgs';
export function ConfirmModal() {
    var globalDispatch = useGlobalDispatch();
    var _a = useGlobalState().modalState, modalState = _a === void 0 ? {} : _a;
    var message = modalState.message, header = modalState.header;
    function closeModal() {
        globalDispatch({ type: 'set modal active', payload: { modal: null } });
    }
    return (_jsx(Modal, __assign({ noOffClickClose: true, altCancelButton: true, overrideCancel: 'Done', closeModal: closeModal, buttonPosition: 'center' }, { children: _jsxs(StyledConfirmationModal, { children: [_jsx(CircleCheck, {}, void 0),
                header ? _jsx("h3", { children: header }, void 0) : null,
                message ? _jsx("p", { children: message }, void 0) : null] }, void 0) }), void 0));
}
var StyledConfirmationModal = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  margin-top: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  svg {\n    width: 88px;\n    height: 88px;\n  }\n  h3 {\n    margin-top: 32px;\n\n    font-size: 2.4rem;\n    letter-spacing: -0.35px;\n    font-weight: 300;\n    color: #444444;\n  }\n  p {\n    font-size: 1.5rem;\n    line-height: 1.6;\n    max-width: 400px;\n    margin-top: 0;\n    margin-bottom: 100px;\n    color: #666666;\n  }\n"], ["\n  height: 100%;\n  margin-top: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  svg {\n    width: 88px;\n    height: 88px;\n  }\n  h3 {\n    margin-top: 32px;\n\n    font-size: 2.4rem;\n    letter-spacing: -0.35px;\n    font-weight: 300;\n    color: #444444;\n  }\n  p {\n    font-size: 1.5rem;\n    line-height: 1.6;\n    max-width: 400px;\n    margin-top: 0;\n    margin-bottom: 100px;\n    color: #666666;\n  }\n"])));
var templateObject_1;
